export default "__VITE_ASSET__C3boyqu9__"